// @Date: 02/20/2024
// @Note: Merged Cart stuff from js-index.js
// Check List - Need to Confirm embroidery & Free Gift feature works.
// https://swedenunlimited.atlassian.net/l/cp/a1Te11A6
// https://swedenunlimited.atlassian.net/l/cp/ZAXt6Ptt

const getSectionInnerHTML = (html, selector) => {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

class Cart extends HTMLElement {
  constructor() {
    super();
    this.cart = this;
    this.sectionsToRender = this.getSectionsToRender().map((section) => section.id);
    this.initSelectors();
    this.initFunction();
  }

  initSelectors() {
    this.giftBoxBlock = this.querySelector('[data-cart-gift-box]');
    this.giftVariantId = this.giftBoxBlock && this.giftBoxBlock.dataset.variantId;

    this.recipientName = this.querySelector('#giftbox-notes-recipient');
    this.cartNote = this.querySelector('#giftbox-notes-message');

    this.editGiftButton = this.querySelector('[data-js-edit-gift-note]');
    this.giftNoteAdded = this.querySelector('#gift-note-added');
  }

  initFunction() {
    document.addEventListener('change', (evt) => {
      if (evt.target.hasAttribute('data-js-add-gift-box') || evt.target.closest('[data-js-add-gift-box]')) {
        if (evt.target.checked) {
          this.addGiftProduct(evt);
        } else {
          this.removeLineItem(this.giftVariantId);
        }
      }
    })

    document.addEventListener('click', (evt) => {
      if (evt.target.hasAttribute('data-js-save-gift-note') || evt.target.closest('[data-js-save-gift-note]')) {
        this.saveNote(evt);
      }
    })
    document.addEventListener('click', (evt) => {
      if (evt.target.hasAttribute('data-js-edit-gift-note') || evt.target.closest('[data-js-edit-gift-note]')) {
        this.editNote(evt);
      }
    })
    document.addEventListener('click', (evt) => {
      if (evt.target.hasAttribute('data-js-remove-gift-note') || evt.target.closest('[data-js-remove-gift-note]')) {
        this.removeNote(evt);
      }
    })
    document.addEventListener('click', (evt) => {
      if (!evt.target.closest('[data-cart-gift-box]')) {
        this.giftBoxBlock.classList.remove('edit-note');
      }
    })

    if (this.giftBoxBlock.classList.contains('hide-giftnote')) {
      const removeNoteBtn = document.querySelector('[data-js-remove-gift-note]');
      removeNoteBtn.click();
    }

    // $(document).off('click', '[data-quickadd-id]');
    $(document).on('click', '[data-quickadd-id]', (e) => {
      let _this = $(e.currentTarget);
      
      if (!e.currentTarget.classList.contains('sold-out')) {
        if (e.currentTarget.dataset.handle == 'membership' && theme.is_member == 'true') {
        } else {
          if (_this.hasClass('quick-add-btn')) {
            if (window.matchMedia("(min-width: 601px)").matches) {
              loadingBarTrigger('start');
              this.itemAdd(_this.attr('data-quickadd-id'), 1, _this);
            }
          } else {
            loadingBarTrigger('start');
            this.itemAdd(_this.attr('data-quickadd-id'), 1, _this);
          }
        }
      }
    });

    // jQuery: need to refactor to JS
    // $(document).on('click', '[data-quickadd-id]', (e) => {
    //   this.handleProductAdd(e);
    // });

    $(document).off('click', '.item-remove')
    $(document).on('click', '.item-remove', (e) => {
      e.preventDefault();
      let _this = $(e.currentTarget);
      const item = _this.closest('.item');
      loadingBarTrigger('start');
  
      // remove item div
      item.fadeOut()
        .delay(300).remove();
  
      // trigger ajax update
      this.updateItem(item, 0, null)
    });

    $(document).off('click', '.item-edit')
    $(document).on('click', '.item-edit',  (e) => {
      let _this = $(e.currentTarget);
      let item = _this.closest('.item');
      let itemVariants = item.find('.item-info-variants');
      
      if (itemVariants.val() != itemVariants.attr('data-select-original')) {
        loadingBarTrigger('start');

        // remove current variant ID
        this.updateItem(item, 0, () => {
          var quantity = parseInt(item.find(".item-info-footer .item-quantity-current").text());
          this._addProduct({
            items: [{
              id: itemVariants.val(),
              quantity: quantity
            }],
            sections: this.sectionsToRender
          }, (response) => {
            this.handleCartContent(response, false);
          })
        });
  
        // update item ID and variant text selected variant
        item.attr('data-item-id', itemVariants.val());
  
        item.find('.item-info-variant-current').text(itemVariants.find('option:selected').text());
  
        itemVariants.attr('data-select-original', itemVariants.val());
      }
  
      _this.toggleText('Edit', 'Done');
      item.find('.item-action-reveal').toggleClass('active');

      if (item.find('.item-action-reveal select')) {
        if (item.find('.item-action-reveal').hasClass('active')) {
          item.find('.item-action-reveal select').attr('disabled', false);
        } else {
          item.find('.item-action-reveal select').attr('disabled', true);
        }
      }
    });
  
    // item quantity adjustments
    $(document).off('click', '.item-quantity button')
    $(document).on('click', '.item-quantity button', (e) => {
      e.preventDefault();

      let _this = $(e.currentTarget);
      let item = _this.closest('.item');
      let itemProductID = item.attr('data-product-id');
      let itemQuantity = _this.closest('.item-quantity');
      let quantityMax = itemQuantity.attr('data-quantity-max');
      let quantityMin = itemQuantity.attr('data-quantity-min');
      let quantityCurrent = _this.siblings('.item-quantity-current');
      let quantityCurrentVal = quantityCurrent.text()
        ? parseInt(quantityCurrent.text())
        : parseInt(quantityCurrent.val());
      let quantityAction = _this.hasClass('item-quantity-increase')
        ? 'increase'
        : 'decrease';

      if (frgiSystem) {
        $('#qty-plus').prop('disabled', true);
        $('#qty-minus').prop('disabled', true);
      }

      let quantityNewVal = quantityAction == 'increase' && quantityCurrentVal < quantityMax
        // increase quantity
        ? quantityCurrentVal + 1
        // else if is decrease and quantity isn't 0
        : quantityAction == 'decrease' && quantityCurrentVal > quantityMin
          // decrease quantity
          ? quantityCurrentVal - 1
          // else, stay at current quantity
          : quantityCurrentVal
      if (itemProductID == 4844103532587 && quantityNewVal < 50) {

        $('#giftcard-qty2').css('display', 'none');
        if (document.URL.includes("/cart")) {
          $('#giftcard-qty').css('display', 'none');
        }
      }
      // Control of 50 qty of GiftCard	
      if (itemProductID == 4844103532587 && quantityNewVal > 50) {
        $('#giftcard-qty2').css('display', 'inline-block');
        if (document.URL.includes("/cart")) {
          $('#giftcard-qty').css('display', 'inline-block');
        }
      }
      else {

        item.find('.item-quantity-current')
          .text(quantityNewVal).val(quantityNewVal);
        this.updateItem(item, quantityNewVal, null);
        quantityNewVal == 0 ? item.remove() : '';
      }
      if (frgiSystem) {
        setTimeout(function () {
          $('#qty-plus').prop('disabled', false);
          $('#qty-minus').prop('disabled', false);
        }, 2500);
      }
    });

    document.addEventListener('input', (evt) => {
      if (evt.target == this.cartNote) {
        this.cartNote.value = this.cartNote.value.replace( /[^a-zA-Z0-9\s&'"*@?.,!]/gm, '');
      }

      if (evt.target == this.recipientName) {
        this.recipientName.value = this.recipientName.value.replace( /[^a-zA-Z0-9\s&'"*@?.,!]/gm, '');
      }
    })

    document.addEventListener('paste', (evt) => {
      if (evt.target == this.cartNote) {
        this.cartNote.value = this.cartNote.value.replace( /[^a-zA-Z0-9\s&'"*@?.,!]/gm, '');
      }

      if (evt.target == this.recipientName) {
        this.recipientName.value = this.recipientName.value.replace( /[^a-zA-Z0-9\s&'"*@?.,!]/gm, '');
      }
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-template',
        target: '#cart-content',
        selector: '#cart-content',
      },
      {
        id: 'mini-cart',
        target: '#minicart-slide',
        selector: '#minicart-slide',
      },
      {
        id: 'header_menu',
        target: '.cart-item-count',
        selector: '.cart-item-count',
      },
    ];
  }

  itemAdd(variantId, qty, _this) {
    if (_this && _this.is('[data-embroidery]')) {
        $.ajax({
          type: 'POST',
          dataType: 'html',
          url: `/cart/add.js`,
          data: {
            items: [
              {
                id: variantId,
                quantity: qty,
                properties: {
                  'embroidery text': _this.attr('data-embroidery'),
                  'embroidery-id': _this.attr('data-product-id'),
                  'embroidery-color': _this.attr('data-embroidery-color')
                }
              },
              {
                id: _this.attr('data-product-id'),
                quantity: qty,
                properties: {
                  'embroidery text': _this.attr('data-embroidery'),
                  'embroidery-id': _this.attr('data-quickadd-id'),
                  'embroidery-color': _this.attr('data-embroidery-color')
                }
              }
            ],
            sections: this.sectionsToRender
          },
          error: (data) => {
            console.error(data);

            loadingBarTrigger('done');
          },
          success: (response) => {
            this.handleCartContent(JSON.parse(response), true);
            // updateGiftboxControl(variantId);
            if (frgiSystem) {
              controlGiftSystemUpdate(true, false);
            }
          }
        });
    }
    else {
      if (variantId != theme.giftbox_id) {
        jQuery.getJSON('/cart.js', (cart) => {
          const isMembershipExist = cart.items.filter((item) => item.handle == "membership" && item.id == variantId).length > 0;
          if (isMembershipExist) {
            loadingBarTrigger('done');
            return
          }

          const properties = {};
          if (typeof _this.data('isMembershipItem') !== 'undefined') {
            properties._membership_product = true;
          } else {
            const d = new Date;
            d.setHours(0, 0, 0); // arguments are hours, minutes, seconds
            let pTimeStamp = Math.round(new Date(d) / 1000);
            if (pTimeStamp % 2 == 1) {
              pTimeStamp = pTimeStamp - 1;
            }
            properties['_currentDate'] = pTimeStamp;
          }

          if (parseFloat(theme.member_discount)) {
            properties['_discount_percent'] = theme.member_discount;
          }
          
          $.ajax({
            type: 'POST',
            dataType: 'html',
            url: `/cart/add.js`,
            data: {
              id: variantId,
              quantity: qty,
              properties: properties,
              sections: this.sectionsToRender
            },
            error: (data) => {
              console.error(data);
              loadingBarTrigger('done');
            },
            success: (response) => {
              loadingBarTrigger('move');
              this.handleCartContent(JSON.parse(response), true);

              if (frgiSystem) {
                controlGiftSystemUpdate(true, false);
              }
            }
          });
				})
			}
		}
	}

  handleCartContent(response, openDrawer = false, removeOrAdjustQty = false) {
    this.getSectionsToRender().forEach((section => {
      const element = document.querySelector(`#shopify-section-${section.id}`);
      if (element) {
        const elementToReplace = element?.querySelector(section.target)
        if (elementToReplace) {
          elementToReplace.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
          elementToReplace.classList.remove('hidden');
        }
      }
    }));

    this.initSelectors();

    if (typeof initFields === 'function') {
      initFields();
    }

    window._rkUnloadPage('ajax_cart');
    window._rkLoadPage('ajax_cart');

    loadingBarTrigger('done');

    const minicartClose = $('#minicart-close, #minicart-overlay');
    minicartClose.click(function () {
      $(html).removeClass('minicart_active');
    });

    if (typeof cartTotalUpdate === 'function') {
      cartTotalUpdate();
    }

    (openDrawer)
      ? $('#minicart-trigger').trigger('click') : '';
  }

  checkCartStatus(cart) {
    let hasOnlyGiftCard = false;
    if (typeof cart.items !== 'undefined' && cart.items.length === 1 && cart.items[0].handle === theme.giftProduct) {
      hasOnlyGiftCard = true;
    }

    return hasOnlyGiftCard;
  }

  // Main Cart Add, Edit, Remove, here
  updateItem(item, qty, callback) {
    const data = {
      updates: {}
    }

    data.updates[item.attr('data-item-key')] = qty
    data.sections = 'cart-template,mini-cart,header_menu'
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((blob) => blob.json())
      .then((response) => {
        if (typeof callback === 'function') {
          callback(response);
        } else {
          this.handleCartContent(response, false, true)

          // Migrated over from js-index.js
          // To do list: need to check the status
          if (item.data('product-emb')) {
            let productEmb = $(`[data-item-id=${item.attr('data-product-emb')}][data-product-emb]`);
            $.post(`/cart/update.js?updates[${productEmb.attr('data-item-key')}]=0`).always(function (data) {
              productEmb.remove();
            })
          }

          if (frgiSystem) {
            if (!document.URL.includes("/cart")) {
              controlGiftSystemUpdate(true, false);
            }
            else {
              controlGiftSystemUpdate(false, true)
            }
          }
        }
      });
  }
  
  // Gift Related Things here
  addGiftProduct(evt) {
    evt.preventDefault();
    const quantity = 1;
    const properties = {};

    const item = {
      id: this.giftVariantId,
      quantity: quantity,
      properties: properties
    };

    this._addProduct({
      items: [item],
      sections: this.sectionsToRender
    }, (response) => {
      this.handleCartContent(response, false);
      setTimeout(() => {
        this.giftBoxBlock.classList.add('edit-note');
      }, 300)
    })
  }

  removeLineItem(variantId) {
    const data = {
      updates: {},
      attributes: {
        Recipient: '',
        Note: ''
      }
    }

    data.updates[variantId] = 0
    data.sections = 'cart-template,mini-cart,header_menu'

    this.giftBoxBlock.classList.remove('edit-note');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((blob) => blob.json())
      .then((response) => {
        this.handleCartContent(response, false, true)
      });
  }

  saveNote(evt) {
    evt.preventDefault();
    this.giftBoxBlock.classList.remove('show-error');

    const recipientName = document.querySelector('#giftbox-notes-recipient');
    const cartNote = document.querySelector('#giftbox-notes-message');
    const recipientNameValue = recipientName.value.trim();
    const cartNoteValue = cartNote.value.trim();
    if (recipientNameValue.length > 0) {
      if (recipientNameValue == recipientName.dataset.originalValue && cartNoteValue == cartNote.dataset.originalValue) {
        return;
      }

      const attributes = {
        Recipient: recipientNameValue,
        Note: cartNoteValue
      };

      this.giftBoxBlock.classList.remove('edit-note');
      this.giftNoteAdded.classList.remove('hide');
      if (this.editGiftButton) {
        this.editGiftButton.textContent = 'Edit';
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify({
          attributes: attributes,
          sections: this.sectionsToRender
        })
      })
        .then((blob) => blob.json())
        .then((response) => {
          
          this.recipientName.dataset.originalValue = this.recipientName.value
          this.cartNote.dataset.originalValue = this.cartNote.value
        });
    } else {
      this.giftBoxBlock.classList.add('show-error');
    }
  }

  editNote(evt) {
    evt.preventDefault();
    this.giftBoxBlock.classList.toggle('edit-note');
  }

  removeNote(evt) {
    if (this.recipientName.value == '') {
      return;
    } else {
      this.giftNoteAdded.classList.add('hide');
      if (this.editGiftButton) {
        this.editGiftButton.textContent = 'Add a Note +';
      }
      this.recipientName.value = ''
      this.cartNote.value = ''

      if (this.recipientName.dataset.originalValue != '') {
        evt.preventDefault();
        const attributes = {
          Recipient: '',
          Note: ''
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json"
          },
          body: JSON.stringify({
            attributes: attributes,
            sections: this.sectionsToRender
          })
        })
          .then((blob) => blob.json())
          .then((response) => {
            this.recipientName.dataset.originalValue = ''
            this.recipientName.value = ''

            this.cartNote.dataset.originalValue = ''
            this.cartNote.value = ''
          });
      }
    }
  }

  _addProduct(data, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const error_msg = response.description;
          return;
        } else {
          if (typeof callback === 'function') {
            callback(response)
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
  }

  handleProductAdd(e) {
    loadingBarTrigger('start');
    const _this = $(e.currentTarget), quantity = 1, variantId = _this.attr('data-quickadd-id');

    jQuery.getJSON('/cart.js', (cart) => {
      const isMembershipExist = cart.items.filter((item) => item.handle == "membership" && item.id == variantId).length > 0;
      if (isMembershipExist) {
        loadingBarTrigger('done');
        return
      }

      const properties = {};
      if (typeof _this.data('isMembershipItem') !== 'undefined') {
        properties._membership_product = true;
      } else {
        const d = new Date;
        d.setHours(0, 0, 0); // arguments are hours, minutes, seconds
        let pTimeStamp = Math.round(new Date(d) / 1000);
        if (pTimeStamp % 2 == 1) {
          pTimeStamp = pTimeStamp - 1;
        }
        properties['_currentDate'] = pTimeStamp;
      }

      if (parseFloat(theme.member_discount)) {
        properties['_discount_percent'] = theme.member_discount;
      }
      
      this._addProduct({
        items: [{
          id: variantId,
          quantity: quantity,
          properties: properties
        }],
        sections: this.sectionsToRender
      }, (response) => {
        this.handleCartContent(response, false);
        this.classList.add('has_items');
        $('#minicart-trigger').trigger('click');
      })
    });
  }
}

if (!customElements.get("section-cart")) {
  customElements.define("section-cart", Cart);
}